import { render } from "./ProductOrderAnalysis.vue?vue&type=template&id=6ae0dba4&scoped=true"
import script from "./ProductOrderAnalysis.vue?vue&type=script&lang=js"
export * from "./ProductOrderAnalysis.vue?vue&type=script&lang=js"

import "./ProductOrderAnalysis.vue?vue&type=style&index=0&id=6ae0dba4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae0dba4"]])

export default __exports__